import { createFileRoute, Link } from "@tanstack/react-router";
import { Arrow } from "@/components/icons";
import { routeHead } from "@/components/seo";
import { pageMeta, packages, site } from "@/content";
import { TiltCard } from "@/components/motion";

const ROUTE = "/packages";
export const Route = createFileRoute("/packages")({
  head: () => routeHead(ROUTE),
  component: Page,
});

function Page() {
  const p = pageMeta(ROUTE)!;
  return (
    <div className="bg-background text-foreground">
      <section className="border-b border-line">
        <div className="mx-auto max-w-6xl px-6 py-20">
          <h1 className="hero-enter mt-4 max-w-3xl font-serif text-4xl leading-[1.1] text-ink sm:text-5xl">
            {p.h1}
          </h1>
          <p className="hero-enter-delay mt-6 max-w-2xl text-lg leading-relaxed text-ink/80">
            {p.description}
          </p>

          <div className="stagger mt-14 grid gap-6 md:grid-cols-3">
            {packages.map((pkg, idx) => (
              <TiltCard
                key={pkg.name}
                className={`card-premium flex h-full flex-col p-8 ${idx === 1 ? "border-teal" : ""}`}
              >
                <span className="tier-badge">
                  {idx === 0 ? "Foundation" : idx === 1 ? "Most common" : "Broader scope"}
                </span>
                <h2 className="mt-3 font-serif text-2xl text-ink">{pkg.name}</h2>
                <p className="mt-4 flex-1 leading-relaxed text-ink/80">{pkg.summary}</p>
                <Link
                  to={site.primaryCta.href}
                  className="link-underline mt-8 inline-flex items-center gap-2 text-sm font-medium text-ink hover:text-teal"
                >
                  Discuss this scope <Arrow className="h-4 w-4" />
                </Link>
              </TiltCard>
            ))}
          </div>

          <p className="reveal mt-10 max-w-3xl text-sm text-subtle">
            Each engagement is scoped around transaction volume, payroll, entities, reporting and
            the finance tasks NextEra will manage. Final pricing is provided after a Strategic
            Finance Review.
          </p>
        </div>
      </section>
    </div>
  );
}
